import { AssetProps, RichTextParser } from '@r-and-a-shared-ui/common-ui';
import classnames from 'classnames';
import stylesSSO from './RichTextWithAssetSSO.module.scss';
import stylesPP from './RichTextWithAssetPP.module.scss';

import Image from 'next/image';
import {
  getProjectType,
  ProjectTypes,
  redirectTo,
} from '@r-and-a-shared-ui/utils';

export interface RichTextWithAssetProps {
  key: string;
  content?: string;
  desktopAsset?: AssetProps;
  mobileAsset?: AssetProps;
  url?: string;
  textSize?: string;
}

export function RichTextWithAsset(props: RichTextWithAssetProps) {
  const { desktopAsset, mobileAsset, textSize } = props;
  const projectType = getProjectType();
  const styles =
    projectType === ProjectTypes.PlayerPortals ? stylesPP : stylesSSO;

  const textSizeClass = textSize ? styles[`text-size--${textSize}`] : undefined;

  return (
    <div className={classnames(styles['container'], textSizeClass)}>
      {props.content && <RichTextParser richText={props.content} />}
      <div className={`${styles['image__desktop']}`}>
        {desktopAsset?.url && (
          <Image
            src={desktopAsset?.url}
            onClick={() => {
              redirectTo(props.url, false, true, false);
            }}
            alt={desktopAsset?.description}
            width={desktopAsset?.width || 300}
            height={desktopAsset?.height || 200}
          />
        )}
      </div>
      <div className={`${styles['image__mobile']}`}>
        {mobileAsset?.url && (
          <Image
            src={mobileAsset?.url}
            alt={mobileAsset?.description}
            width={mobileAsset?.width || 300}
            height={mobileAsset?.height || 200}
          />
        )}
      </div>
    </div>
  );
}

export default RichTextWithAsset;
